export default "__VITE_ASSET__e2953b9c__"